/**
 * Dirección de la llamada: entrante o saliente.
 *
 * Espejo de `backend/app/utils/direction.py`. La lista de tokens y el orden del
 * COALESCE tienen que coincidir con el backend: si divergen, la UI oculta la
 * boleta en llamadas que el backend sí calificó (o al revés), y el usuario ve
 * una contradicción sin explicación.
 */

const INBOUND_TOKENS = ['entrante', 'entrada', 'incoming', 'inbound'];
const OUTBOUND_TOKENS = ['salida', 'saliente', 'outgoing', 'outbound'];

/** Dirección efectiva: 'inbound' | 'outbound' | null si no se puede clasificar. */
export function classifyDirection(call) {
  if (!call) return null;
  const raw = (call.direccion_inicial || '').trim() || call.direction || '';
  const value = String(raw).trim().toLowerCase();
  if (!value) return null;
  if (OUTBOUND_TOKENS.some((t) => value.includes(t))) return 'outbound';
  if (INBOUND_TOKENS.some((t) => value.includes(t))) return 'inbound';
  return null;
}

/**
 * ¿La originó el agente?
 *
 * Lo que no se puede clasificar NO es saliente: ante la duda se muestra la
 * boleta, igual que en el backend. Ocultarla de más esconde evaluación real.
 */
export function isOutboundCall(call) {
  return classifyDirection(call) === 'outbound';
}

export function directionLabel(call) {
  const d = classifyDirection(call);
  if (d === 'outbound') return 'Saliente';
  if (d === 'inbound') return 'Entrante';
  return '-';
}

/** Por qué la boleta no aplica. Mismo texto que `boleta.OUTBOUND_EXCLUSION_REASON`. */
export const OUTBOUND_BOLETA_REASON =
  'La guía de nueve criterios evalúa atención entrante; no aplica a llamadas que origina el agente.';
